import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes"; // Add your route string here if needed

export const fetchCategoryProducts = async ({
  search = "",
  catId = "",
  userId = "",
  page = 1,
  limit = 10,
  categories = "",
  industries = "",
  segment = "",
  minPrice = "",
  maxPrice = "",
  sortBy = "",
  sortOrder = "",
  first = false
}) => {
  // Handle array values
  const categoryStr = Array.isArray(categories) ? categories.join(",") : categories;
  const industryStr = Array.isArray(industries) ? industries.join(",") : industries;

  // Build raw query string manually to prevent URL encoding
  const queryString = `search=${search}&catId=${catId}&userId=${userId}&page=${page}&limit=${limit}&categories=${categoryStr}&industries=${industryStr}&segment=${segment}&minPrice=${minPrice}&maxPrice=${maxPrice}&sortBy=${sortBy}&sortOrder=${sortOrder}&first=${first}`;

  const response = await apiService.get(`${apiRoutes.categoryProductList}?${queryString}`);
  return response.data;
};


export const popularMentions = async ({
  search = "",
  catId = "",
  page = 1,
  limit = 10,
}) => {
  const params = new URLSearchParams({
    search,
    catId,
    page: page.toString(),
    limit: limit.toString(),
  });
  const response = await apiService.get(
    `${apiRoutes.popularMentions}?${params.toString()}`
  );
  return response.data;
};

export const reviewPopularMentions = async ({
  search = "",
  productId = "",
  page = 1,
  limit = 10,
}) => {
  const params = new URLSearchParams({
    search,
    productId,
    page: page.toString(),
    limit: limit.toString(),
  });
  const response = await apiService.get(
    `${apiRoutes.reviewPopularMentions}?${params.toString()}`
  );
  return response.data;
};

export const fetchProductBySlug = async ({ slug, userId }) => {
  const params = new URLSearchParams({
    slug,
    userId,
  });
  const response = await apiService.get(
    `${apiRoutes.categoryProductDetail}?${params.toString()}`
  );
  return response.data;
};

export const marketSegmentsList = async () => {
  const response = await apiService.get(apiRoutes.marketSegmentsList);
  return response.data;
};

export const integrationsList = async () => {
  const response = await apiService.get(apiRoutes.integrationsList);
  return response.data;
};

export const languagesList = async () => {
  const response = await apiService.get(apiRoutes.languagesList);
  return response.data;
};

export const rolesList = async () => {
  const response = await apiService.get(apiRoutes.rolesList);
  return response.data;
};

export const industriesList = async () => {
  const response = await apiService.get(apiRoutes.industriesList);
  return response.data;
};



export const addProduct = async ({payload}) => {
  const response = await apiService.post(apiRoutes.addProduct,payload);
  return response.data;
};

export const updateProduct = async ({payload,id}) => {
  const response = await apiService.put(`${apiRoutes.addProduct}/${id}`,payload);
  return response.data;
};


export const deleteProduct = async ({id}) => {
  const response = await apiService.delete(`${apiRoutes.addProduct}/${id}`);
  return response.data;
};






